import {toast} from "react-toastify";

export const PromiseToaast = (
    promise,
    message
) => {
    return toast.promise(promise, message, {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        rtl: true,
        theme: "dark",
        style: {fontFamily: "Vazir", fontSize: 14},
    });
};

export const WarningToaast = (message) => {
    return toast.warn(message, {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        rtl: true,
        theme: "dark",
        style: {fontFamily: "Vazir", fontSize: 14},
    });
};

export const ErrorToaast = (message) => {
    return toast.error(message, {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        rtl: true,
        theme: "dark",
        style: {
            fontFamily: "Vazir",
            fontSize: 14,
        },
    });
};
export const SuccessToaast = (message) => {
    return toast.success(message, {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        rtl: true,
        theme: "dark",
        style: {
            fontFamily: "Vazir",
            fontSize: 14,
        },
    });
};
export const InfoToaast = (message) => {
    return toast.info(message, {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        rtl: true,
        theme: "dark",
        style: {
            fontFamily: "Vazir",
            fontSize: 14,
        },
    });
};
